{
  "greeting": {
    "salam": "Ассаламу алейкум",
    "salamWithName": "Ассаламу алейкум, {{name}}"
  },
  "dock": {
    "saved": "Сохранённое",
    "savedVerses": "Сохранённые аяты",
    "tasks": "Задачи",
    "notes": "Заметки"
  },
  "actions": {
    "save": "Сохранить",
    "cancel": "Отмена",
    "close": "Закрыть",
    "delete": "Удалить",
    "rename": "Переименовать",
    "dismiss": "Скрыть",
    "loading": "Загрузка…",
    "reload": "Перезагрузить",
    "retry": "Повторить",
    "expand": "Развернуть",
    "collapse": "Свернуть"
  },
  "nav": {
    "appNavigation_aria": "Навигация по приложению"
  },
  "tabs": {
    "home": "Главная",
    "tasks": "Задачи",
    "notes": "Заметки",
    "more": "Ещё"
  },
  "more": {
    "daily": "Ежедневно",
    "account": "Аккаунт",
    "savedVerses": "Сохранённые аяты",
    "qibla": "Кибла",
    "prayerTimes": "Время молитв и напоминания",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Управляется через ваш аккаунт Rhemn",
    "upgrade": "Улучшить",
    "privacyPolicy": "Политика конфиденциальности",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Назад",
    "deleteAccount": "Удалить аккаунт"
  },
  "reflection": {
    "dismiss_aria": "Скрыть размышление"
  },
  "app": {
    "loading_aria": "Rhemn загружается",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Управляйте подпиской Rhemn Pro в вебе. Pro открывается здесь автоматически, когда вы входите с аккаунта с подпиской."
  },
  "header": {
    "qiblaDirection_aria": "Направление Qibla",
    "prayerTimes_aria": "Времена молитв",
    "prayerTimesTitle": "Времена молитв",
    "method": "Метод",
    "methodHelp": "Метод влияет на рассчитанные времена"
  },
  "search": {
    "search_aria": "Поиск",
    "searchLabel": "Поиск",
    "searchWeb_placeholder": "Поиск в интернете"
  },
  "focus": {
    "input_placeholder": "Что важнее всего сегодня?",
    "example_worship": "Совершить намаз с вниманием, без спешки",
    "example_kindness": "Позвонить маме, просто чтобы выслушать",
    "example_reflect": "Поразмышлять о намерении с аятом дня",
    "saveIntention_aria": "Сохранить намерение",
    "celebration": "🤲 Машаллах"
  },
  "profile": {
    "profileFallback": "Профиль",
    "profileAndAccount_aria": "Профиль и аккаунт",
    "profileDialog_aria": "Профиль",
    "editName_aria": "Изменить имя",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Управление подпиской",
    "manageSubscription_aria": "Управление подпиской Rehmn Pro",
    "anonymousAnalytics": "Анонимная аналитика",
    "anonymousAnalyticsNote": "Только агрегированно — никогда не связано с вами",
    "shareAnalytics_aria": "Делиться анонимной аналитикой использования",
    "signOut": "Выйти",
    "signingOut": "Выход…",
    "signOut_aria": "Выйти из Rehmn",
    "restorePurchases": "Восстановить покупки",
    "restorePurchases_aria": "Восстановить предыдущие покупки"
  },
  "background": {
    "loading": "Загрузка фона...",
    "fallbackNotice": "Используется запасное изображение (Unsplash API недоступен)",
    "noImage": "Фоновое изображение недоступно",
    "error": "Ошибка: {{message}}",
    "photoByOnUnsplash": "Фото: <photographer>{{name}}</photographer> на <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Что-то пошло не так",
    "fallbackMessage": "Произошла непредвиденная ошибка."
  },
  "theme": {
    "switchToLight_title": "Переключить на светлую тему",
    "switchToDark_title": "Переключить на тёмную тему"
  },
  "upgradeCta": {
    "upgradeToPro": "Перейти на Pro",
    "restorePurchases": "Восстановить покупки",
    "restoring": "Восстановление…",
    "restoreEmpty": "Покупки не найдены.",
    "pricePerMonth": "{{price}} / месяц",
    "pricePerYear": "{{price}} / год",
    "purchasePending": "Ожидает одобрения. Pro активируется автоматически, как только покупка будет одобрена.",
    "storeUnavailable": "App Store сейчас недоступен. Повторите попытку чуть позже.",
    "purchaseFailed": "Не удалось завершить покупку. Повторите попытку чуть позже."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · −25% на первый год",
    "title": "Для часов между вашими молитвами.",
    "body": "Голосовые заметки, которые расшифровываются, кратко пересказываются и становятся задачами. Планировщик дня, построенный вокруг времени ваших молитв. Заметки с ИИ.",
    "price": "$29.99",
    "period": "за первый год",
    "priceIos": "−25% на первый год",
    "terms": "Затем $39.99 в год. Код {{code}} уже применён.",
    "termsIos": "Продлевается по обычной годовой цене. Введите код {{code}} в App Store.",
    "free": "Время молитв, кибла, аят дня и задачи остаются бесплатными.",
    "cta": "Перейти на Pro",
    "dismiss": "Не сейчас"
  },
  "planChooser": {
    "monthly": "Ежемесячно",
    "yearly": "Ежегодно",
    "yearlyValue": "Четыре месяца в подарок.",
    "freeNote": "Время намаза, кибла, аят дня и задачи — бесплатно. Rhemn Pro добавляет:",
    "includes_planner": "План дня, выстроенный вокруг пяти намазов, и «Спланировать день»",
    "includes_insights": "Quran Insights — задайте вопрос о любом аяте и прочитайте его контекст",
    "includes_reflections": "Размышления над аятом дня, написанные под ваше намерение",
    "includes_notes": "Заметки и голосовые заметки с ИИ-резюме и правкой",
    "includes_extras": "Сохранённые аяты, карточки аятов, серии дней и прогноз на 5 дней",
    "renewsMonthly": "Продлевается каждый месяц до отмены",
    "renewsYearly": "Продлевается каждые 12 месяцев до отмены",
    "continue": "Продолжить",
    "renewalTerms": "Оплата списывается с вашего Apple ID при подтверждении. Подписка продлевается автоматически, если автопродление не отключить не позднее чем за 24 часа до конца периода. Управлять подпиской или отменить её можно в любое время в настройках Apple ID.",
    "retry": "Повторить"
  },
  "streak": {
    "badge_aria": "Ежедневная серия — {{count}} дн.",
    "title": "Ежедневная серия",
    "daysWithCount": "Серия: {{count}} дн.",
    "start": "Начните сегодня — уделите минуту аяту или отметьте молитву.",
    "prayedToday": "Помолились сегодня",
    "readVerse": "Прочитали сегодняшний аят",
    "autoHint": "Аят отмечается сам, когда вы уделяете ему минуту.",
    "milestoneTitle": "{{count}} дн. с намерением",
    "milestoneBody": "Альхамдулиллях. Поделитесь этой вехой — возможно, кто-то из близких тоже начнёт.",
    "share": "Поделиться",
    "dismiss": "Не сейчас",
    "cardLabel": "дней с намерением",
    "shareCaption": "{{count}} дн. с намерением — rhemn.com",
    "imageSaved": "Изображение сохранено.",
    "couldNotCreateImage": "Не удалось создать изображение. Попробуйте ещё раз."
  },
  "qibla": {
    "compassIcon_aria": "Значок компаса",
    "title": "Направление Qibla",
    "locationUnavailable": "Местоположение недоступно",
    "locating": "Определение…",
    "compass_aria": "Компас Qibla",
    "directionN": "С",
    "directionE": "В",
    "directionS": "Ю",
    "directionW": "З",
    "facingQibla": "Лицом к Qibla",
    "enableLiveCompass": "Включить живой компас",
    "enableLiveCompassNote": "Использует датчик движения, чтобы стрелка поворачивалась вместе с вами — не местоположение",
    "directionToMecca": "Направление на Мекку",
    "enableLocation": "Включите доступ к местоположению, чтобы рассчитать направление",
    "hintLive": "Стрелка отслеживает ориентацию устройства в реальном времени",
    "hintStatic": "Азимут от севера — используйте с компасом для точного направления",
    "live": "Живой",
    "footerVerse": "«Обрати же своё лицо в сторону Заповедной мечети» – Quran 2:144"
  },
  "legal": {
    "links_aria": "Правовая информация",
    "termsOfUse": "Условия использования",
    "privacyPolicy": "Политика конфиденциальности"
  },
  "auth": {
    "signInForPro": "Сначала войдите — ваш Pro всегда с вами."
  },
  "integrations": {
    "row": {
      "label": "Календари и задачи",
      "caption": "Подключено",
      "subNone": "Не подключено",
      "subFree": "Google Календарь, Google Задачи и другие",
      "subAttention": "{{provider}} требует внимания",
      "subPaused": "Синхронизация на паузе"
    },
    "list": {
      "title": "Календари и задачи",
      "subtitle": "Добавьте встречи и дела в свой день.",
      "footnote": "Rhemn читает только то, что нужно, и никогда не сохраняет ваши события.",
      "privacy": "Политика конфиденциальности",
      "connect": "Подключить",
      "connect_aria": "Подключить {{what}}",
      "checking": "Проверка…",
      "loadError": "Не удалось загрузить ваши подключения.",
      "tryAgain": "Повторить попытку",
      "offline": "Вы не в сети. Подключитесь, когда снова будете онлайн.",
      "unavailable": "Календари и задачи сейчас недоступны.",
      "disconnected": "{{provider}} отключён.",
      "google": {
        "name": "Google",
        "sub": "Календарь и Задачи",
        "what": "Google Календарь и Задачи"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Задачи и проекты",
        "what": "Todoist"
      },
      "apple": {
        "name": "Календарь и Напоминания",
        "subNative": "На этом {{device}}",
        "subSafari": "В приложении Rhemn для iPhone и Mac"
      },
      "synced": "Синхронизировано {{when}}",
      "connectedSub": "Подключено",
      "syncing": "Синхронизация…",
      "reconnectSub": "Переподключитесь, чтобы синхронизация продолжилась",
      "errorSub": "Последняя синхронизация не завершилась",
      "pausedSub": "На паузе · Rhemn Pro закончился"
    },
    "explainer": {
      "google": {
        "title": "Подключите Google Календарь и Задачи",
        "p1Lead": "Ваш календарь только для чтения",
        "p1Body": "Rhemn показывает ваши события в течение дня и видит, когда вы заняты. Он их не сохраняет.",
        "p2Lead": "Google Задачи — в обе стороны",
        "p2Body": "Выбранные вами списки остаются синхронизированными, так что вы можете отмечать дела где угодно.",
        "p3Lead": "Вы можете отменить в любой момент",
        "p3Body": "Отключите в любое время — здесь или в своём аккаунте Google.",
        "footnote": "Google покажет вам точно, что запрашивает Rhemn."
      },
      "todoist": {
        "title": "Подключите Todoist",
        "p1Lead": "Ваши проекты — в обе стороны",
        "p1Body": "Выбранные вами проекты остаются синхронизированными, так что вы можете отмечать дела где угодно.",
        "p2Lead": "Как это сопоставляется",
        "p2Body": "Приоритеты Todoist становятся Критическим, Высоким, Средним и Низким. Подзадачи глубже одного уровня отображаются как шаги внутри верхней задачи.",
        "p3Lead": "Вы можете отменить в любой момент",
        "p3Body": "Отключите в любое время — здесь или в настройках Todoist.",
        "cta": "Перейти в Todoist",
        "footnote": "Todoist попросит вас подтвердить."
      },
      "skip": "Не сейчас",
      "cancel": "Отмена",
      "waiting": "Ожидание {{provider}}…",
      "safariWaiting": "Завершите в новой вкладке, затем вернитесь сюда.",
      "safariReopen": "Открыть вкладку снова",
      "denied": "{{provider}} не предоставил доступ, поэтому ничего не подключено.",
      "error": "Не удалось подключиться к {{provider}}. Повторите попытку через минуту."
    },
    "detail": {
      "back_aria": "Назад к разделу «Календари и задачи»",
      "syncNow": "Синхронизировать сейчас",
      "intro": "Выберите, что синхронизирует Rhemn. Вы можете изменить это в любое время.",
      "taskLists": "Списки задач",
      "projects": "Проекты",
      "reminders": "Напоминания",
      "calendars": "Календари",
      "rhemnCalendarSub": "Ваше время намаза не считается занятостью",
      "loading": "Загрузка…",
      "loadError": "Не удалось загрузить ваши списки.",
      "emptyGoogle": "В Google Задачах нет списков задач.",
      "emptyTodoist": "В Todoist нет проектов.",
      "addError": "Не удалось добавить {{name}}. Попробуйте ещё раз.",
      "removed": "Удалено из Rhemn. Всё ещё есть в {{provider}}.",
      "undo": "Отменить",
      "prayerTimes": "Добавить время намаза в календарь",
      "prayerTimesSub": "Добавляет пять намазов в календарь под названием Rhemn на ближайшие 7 дней, чтобы никто не назначал встречи поверх них.",
      "prayerTimesOn": "Включено. Добавлено по {{date}}.",
      "prayerTimesWaiting": "Ожидание Google…",
      "prayerTimesDenied": "Google не разрешил это. Ничего не добавлено.",
      "prayerTimesRemoveAsk": "Удалить время намаза Rhemn из вашего календаря?",
      "prayerTimesKeep": "Оставить",
      "prayerTimesRemove": "Удалить",
      "meetingPrompts": "Подсказки для встреч",
      "meetingPromptsSub": "Когда встреча со ссылкой вот-вот начнётся, предложит вести заметки.",
      "busyFootnote": "«Спланировать день» видит только, когда вы заняты, но никогда — о чём ваши встречи.",
      "todoistFootnote": "Приоритеты Todoist становятся Критическим, Высоким, Средним и Низким. Подзадачи глубже одного уровня отображаются как шаги внутри верхней задачи.",
      "reauth": "{{provider}} перестал разрешать Rhemn синхронизацию. Это происходит, если доступ отозван или изменился пароль.",
      "reconnect": "Переподключить",
      "paused": "Синхронизация на паузе, потому что Rhemn Pro закончился. Ваши списки остаются как были.",
      "calendarDenied": "Доступ к календарю отключён.",
      "remindersDenied": "Доступ к напоминаниям отключён.",
      "disconnect": "Отключить {{provider}}",
      "disconnectTitle": "Отключить {{provider}}?",
      "disconnectBody": "В {{provider}} ничего не удаляется.",
      "disconnectRhemnCal": "Ваш календарь времени намаза Rhemn будет удалён из Google Календаря.",
      "disconnectError": "Не удалось отключить {{provider}}. Повторите попытку через минуту.",
      "keepLists": "Оставить мои списки в Rhemn",
      "keepListsSub": "Они перестают синхронизироваться и становятся обычными списками Rhemn.",
      "removeLists": "Удалить их из Rhemn",
      "removeListsSub": "Удаляются только копии в Rhemn.",
      "disconnecting": "Отключение…",
      "appleStop": "Перестать использовать Календарь и Напоминания",
      "appleStopTitle": "Перестать использовать Календарь и Напоминания?",
      "appleStopBody": "Rhemn перестанет показывать ваши события и напоминания. Чтобы полностью убрать доступ, отключите его в Настройках.",
      "justNow": "только что",
      "tasksScope": "Rhemn нужно разрешение на просмотр ваших Google Задач. Переподключитесь и отметьте Задачи, чтобы разрешить это.",
      "calendarsLoadError": "Не удалось загрузить ваши календари.",
      "calendarsEmpty": "В этом аккаунте нет календарей.",
      "calendarsScope": "Rhemn нужно разрешение на просмотр Google Календаря. Переподключите его и отметьте «Календарь», чтобы разрешить доступ.",
      "prayerTimesError": "Не удалось добавить время намаза. Попробуйте ещё раз чуть позже.",
      "remindersEmpty": "В Напоминаниях нет списков.",
      "openSettings": "Открыть Настройки",
      "appleStopCta": "Не использовать"
    },
    "locked": {
      "body": "Видите свои встречи внутри блоков намаза и держите Google Задачи синхронизированными с Rhemn.",
      "googleName": "Google Календарь и Задачи"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "устройство"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, синхронизировано с {{provider}}",
      "unlinkConfirm": "Удалить «{{name}}» из Rhemn? Останется в {{provider}}.",
      "remove": "Удалить",
      "offline": "Офлайн · Изменения синхронизируются с {{provider}}, когда вы вернётесь.",
      "stillSyncing": "Всё ещё синхронизируется с {{provider}}…",
      "failed_one": "{{count}} изменение не дошло до {{provider}}.",
      "failed_few": "{{count}} изменения не дошли до {{provider}}.",
      "failed_many": "{{count}} изменений не дошли до {{provider}}.",
      "failed_other": "{{count}} изменения не дошли до {{provider}}.",
      "retry": "Повторить",
      "needsReconnect": "{{provider}} требует переподключения.",
      "paused": "Синхронизация на паузе · Rhemn Pro закончился.",
      "upgrade": "Улучшить",
      "notSynced": "Не синхронизировано",
      "notSynced_aria": "Не синхронизировано с {{provider}}. Повторить.",
      "remindersOff": "Rhemn не может обратиться к Напоминаниям. Включите их снова в Настройках.",
      "dueToday": "Сегодня",
      "dueTomorrow": "Завтра",
      "googleTasks": "Google Задачи"
    },
    "today": {
      "allDay": "Весь день",
      "more": "+{{count}}",
      "more_aria": "Показать ещё события на весь день: {{count}}",
      "less_aria": "Показать меньше событий на весь день",
      "events_aria": "События",
      "event_aria": "С {{start}} до {{end}}, {{title}}",
      "allDayEvent_aria": "Весь день, {{title}}",
      "untitled": "Занят",
      "now": "Сейчас · до {{end}}",
      "until": "до {{end}}",
      "into": "· заходит в {{prayer}}",
      "loadError": "Не удалось загрузить ваш календарь.",
      "needsReconnect": "Google Календарь нужно переподключить.",
      "scope": "Rhemn не видит ваш Google Календарь. Переподключите его и отметьте «Календарь», чтобы разрешить доступ.",
      "appleOff": "Rhemn не видит ваш календарь. Снова включите доступ в Настройках."
    },
    "plan": {
      "mostlyMeetings": "В основном встречи · свободно {{duration}}",
      "noFreeTime": "Нет свободного времени",
      "aroundMeetings_one": "Спланировано с учётом {{count}} встречи.",
      "aroundMeetings_few": "Спланировано с учётом {{count}} встреч.",
      "aroundMeetings_many": "Спланировано с учётом {{count}} встреч.",
      "aroundMeetings_other": "Спланировано с учётом {{count}} встречи.",
      "settledBusy": "Всё уже вписано между вашими встречами."
    },
    "meeting": {
      "group_aria": "Начинается встреча",
      "now": "сейчас",
      "takeNotes": "Вести заметки",
      "takeNotes_aria": "Вести заметки: {{title}}",
      "dismiss_aria": "Закрыть",
      "announce": "{{title}} начнётся {{when}}.",
      "announceNow": "{{title}} начинается сейчас.",
      "yourMeeting": "Ваша встреча"
    },
    "apple": {
      "primer": {
        "title": "Календарь рядом с намазами",
        "body": "Rhemn читает события и напоминания на этом {{device}}, чтобы разместить их в вашем дне. Они остаются на вашем устройстве. «Спланировать день» использует только время, когда вы заняты.",
        "cta": "Продолжить",
        "skip": "Не сейчас",
        "footnote": "{{device}} спросит дважды: для Календаря и для Напоминаний. Любое из разрешений можно изменить в Настройках."
      }
    }
  }
}
